<template>
  <div>

    <el-form :model="appVersionForm" :rules="rules" ref="appVersionForm" style="margin-right: 30px;">

      <el-form-item label="版本号" :label-width="formLabelWidth" prop="version">
        <el-input v-model="appVersionForm.version" autocomplete="off"></el-input>
      </el-form-item>


      <el-form-item label="App" :label-width="formLabelWidth" prop="appId">

        <el-select style="margin-right: 30px" v-model="appVersionForm.appId" filterable placeholder="请选择App">
          <el-option
            v-for="item in appList"
            :key="item.id"
            :label="item.name"
            :value="item.id" :index="item.id">
          </el-option>
        </el-select>

      </el-form-item>

      <el-form-item label="更新选择" :label-width="formLabelWidth" prop="forceUpdate">

        <el-select style="margin-right: 30px" v-model="appVersionForm.forceUpdate" filterable placeholder="请选择">
          <el-option
            v-for="item in updateChoice"
            :key="item.id"
            :label="item.name"
            :value="item.value" :index="item.id">
          </el-option>
        </el-select>

      </el-form-item>


      <el-form-item label="更新内容" :label-width="formLabelWidth" prop="description">
        <el-input type="textarea" v-model="appVersionForm.description" autocomplete="off"></el-input>
      </el-form-item>


      <el-form-item :label-width="formLabelWidth" label="">
        <div style="margin-right: 30px;">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="confirmAction('appVersionForm')">确 定</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import { getAppList } from '../../api/appManageApi'
  import { handleResponse } from '../../utils/response'

  export default {
    name: 'AddAppVersion',
    props: {
      visible:{
        type: Boolean,
        default: false
      },
      editVersionForm: {
        type: Object,
        default: {}
      }
    },
    watch: {
      editVersionForm (newValue, oldValue) {
        this.appVersionForm = newValue
      },
      visible (newValue, oldValue) {
        if (newValue){
          this.getAppList()
        }
      }
    },
    mounted () {
      this.getAppList()
    },
    methods: {
      closeDialog () {
        this.$emit('clickCancel')
      },
      confirmAction (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.closeDialog()
            // this.clearData()
            this.$emit('clickConfirm', this.appVersionForm)
          } else {
            return false
          }
        })
      },
      getAppList () {
        getAppList().then(response => {
          handleResponse(response, data => {
            this.appList = data.list
          }, error => {
          })
        })
      },
    },
    data () {
      return {
        formLabelWidth: '100px',
        appList: [],
        updateChoice:[
          {
            id:'1',
            name:'强制更新',
            value:1,
          },
          {
            id:'2',
            name:'建议更新',
            value:2,
          },
          {
            id:'3',
            name:'不做任何操作',
            value:0,
          }
        ],
        rules: {
          version: [
            {
              required: true,
              message: '请输入版本号',
              trigger: 'blur'
            }
          ],
          appId: [
            {
              required: true,
              message: '请选择App',
              trigger: 'blur'
            }
          ],
          forceUpdate: [
            {
              required: true,
              message: '请选择是否更新',
              trigger: 'blur'
            }
          ],
          description: [
            {
              required: true,
              message: '请输入更新内容',
              trigger: 'blur'
            }
          ]
        },
        appVersionForm: this.editVersionForm
      }
    }
  }
</script>

<style scoped>

</style>
